// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
/* eslint-disable no-console */
import * as React from "react";
import { diff } from "../libs/diff";
import { getUser } from "../graphql/queries";
import { CreateUserInput, UpdateUserInput, User } from "../API";
import { createUser, updateUser } from "../graphql/mutations";

export const CLEAR_RESULT = "CLEAR_RESULT";

export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

export const NEW_USER = "NEW_USER";
export const NEW_USER_SUCCESS = "NEW_USER_SUCCESS";
export const NEW_USER_FAILURE = "NEW_USER_FAILURE";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const FetchUser = (id: string) => {
  return {
    type: FETCH_USER as typeof FETCH_USER,
    payload: {
      function: getUser,
      params: {
        id,
      },
    },
  };
};

export const NewUser = (input: CreateUserInput) => {
  return {
    type: NEW_USER as typeof NEW_USER,
    payload: {
      function: createUser,
      params: {
        input,
      },
    },
  };
};

export const UpdateUser = (input: UpdateUserInput) => {
  return {
    type: UPDATE_USER as typeof UPDATE_USER,
    payload: {
      function: updateUser,
      params: {
        input,
      },
    },
  };
};

export const ClearResult = () => ({
  type: CLEAR_RESULT as typeof CLEAR_RESULT,
  payload: {},
});

type FetchUserSuccess = {
  type: typeof FETCH_USER_SUCCESS;
  payload: {
    data: {
      getUser: User;
    };
  };
};

type FetchUserFailure = {
  type: typeof FETCH_USER_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type NewCustomerSuccess = {
  type: typeof NEW_USER_SUCCESS;
  payload: {
    data: {
      createCustomer: CreateUserInput;
    };
  };
};

type NewCustomerFailure = {
  type: typeof NEW_USER_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

type UpdateUserSuccess = {
  type: typeof UPDATE_USER_SUCCESS;
  payload: {
    data: {
      updateUser: User;
    };
  };
};

type UpdateUserFailure = {
  type: typeof UPDATE_USER_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
      code?: string;
    };
  };
};

export type UserActions =
  | ReturnType<typeof ClearResult>
  | ReturnType<typeof FetchUser>
  | ReturnType<typeof NewUser>
  | ReturnType<typeof UpdateUser>
  | FetchUserSuccess
  | FetchUserFailure
  | NewCustomerSuccess
  | NewCustomerFailure
  | UpdateUserSuccess
  | UpdateUserFailure;

export interface UserState {
  user?: User;
  isAuthed: boolean;
  result: string;
  error?: { status?: number; message?: string; code?: string };
}

export const InitialUserState: UserState = {
  result: "",
  isAuthed: false,
};

const reducer = (state: UserState, action: UserActions): UserState => {
  switch (action.type) {
    case FETCH_USER: {
      return {
        ...state,
        result: action.type,
      };
    }
    case FETCH_USER_SUCCESS: {
      return {
        ...state,
        result: action.type,
        user: action.payload.data?.getUser,
      };
    }
    case NEW_USER_SUCCESS: {
      return {
        ...state,
        result: action.type,
      };
    }
    case NEW_USER_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case UPDATE_USER: {
      return {
        ...state,
        result: action.type,
      };
    }
    case UPDATE_USER_SUCCESS: {
      return {
        ...state,
        result: action.type,
        user: action.payload.data.updateUser,
      };
    }
    case UPDATE_USER_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case FETCH_USER_FAILURE: {
      return {
        ...state,
        result: action.type,
        error: action.payload.error,
      };
    }
    case CLEAR_RESULT:
      return {
        ...state,
        result: "",
        error: {},
      };
    default:
      return state;
  }
};

export const UserReducer =
  process.env.NODE_ENV === "production"
    ? reducer
    : (state: UserState, action: UserActions) => {
        console.groupCollapsed(action.type);
        console.log("action", action);
        const result = reducer(state, action);
        console.log("diff", diff(state, result));
        console.log("prevState", state);
        console.log("currentState", result);
        console.groupEnd();
        return result;
      };

type ContextState = {
  UserState: UserState;
  UserDispatch(action: UserActions): void;
};

export const UserContext = React.createContext<ContextState>({
  UserState: InitialUserState,
  UserDispatch() {
    console.warn("Context.Provider外からの呼び出し");
  },
});
